module.exports = __webpack_public_path__ + "static/media/podcast.c308d063.png";